import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import ServiceDeskAppBase from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/app-base/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { ServiceDeskSlaSettingsView } from './ui';

export const ServiceDeskSlaSettingsPage = () => (
	<>
		<MarkProductStart />
		<ServiceDeskAppBase appName={APP_NAMES.SLA_SETTINGS}>
			<ThemeProvider theme={{}}>
				<ServiceDeskSlaSettingsView />
			</ThemeProvider>
		</ServiceDeskAppBase>
	</>
);

export default ServiceDeskSlaSettingsPage;
